import { useEffect, useState } from "react";
import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import settings from "../../config/settings";
import NotificationService from "../Notification/notificationService";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";

export interface ShareBarProps {
  targetUserId: number;
}

const ShareBar = ({ targetUserId }: ShareBarProps) => {
  const [url, setUrl] = useState<string | undefined>(undefined);
  const [prettyUrl, setPrettyUrl] = useState<string | undefined>(undefined);

  const { success } = NotificationService();

  const matches = useMediaQuery("(min-width:1430px)");

  const maxChar = matches ? 16 : 8;

  const copyToClipBoard = () => {
    if (url) {
      navigator.clipboard.writeText(url);
      success('"' + prettyUrl + '" copied to clipboard');
    }
  };

  useEffect(() => {
    setUrl(
      settings.PUBLIC_URL +
        "/my-profile/" +
        targetUserId +
        "/" +
        COLLECTION_TAB.COLLECTION +
        "/" +
        COLLECTION_SECTION.OVERVIEW
    );
    setPrettyUrl(
      "collecticos.com/my-profile/" +
        targetUserId +
        "/" +
        COLLECTION_TAB.COLLECTION +
        "/" +
        COLLECTION_SECTION.OVERVIEW
    );
  }, [targetUserId]);

  return (
    <Box
      sx={{
        width: "100%",
        paddingX: "0.5rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box>
        <Box>
          <Typography
            variant="upgradeSubtitle"
            sx={{ color: "white !important", fontWeight: "600 !important" }}
          >
            Share collection
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "end",
            borderRadius: "25px",
            padding: "5px",
            paddingLeft: "10px",
            color: "white",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            width: { xs: "100%", md: "150px" },
          }}
        >
          <Box
            sx={{ width: { xs: "40%", md: "50%" }, boxSizing: "border-box" }}
          >
            <Typography
              noWrap
              variant="upgradeSubtitle"
              sx={{
                fontSize: { xs: "0.75rem !important" },
                color: "white !important",
                fontWeight: "600 !important",
              }}
            >
              {prettyUrl ? prettyUrl.slice(0, maxChar) + "..." : "..."}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "end",
              width: { xs: "60%", md: "50%" },
              maxHeight: "40px !important",
            }}
          >
            <IconButton
              size="small"
              sx={{ backgroundColor: "white", color: "" }}
              onClick={copyToClipBoard}
            >
              <InsertLinkIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ShareBar;
